import { render } from "./FormCompletedPage.vue?vue&type=template&id=aa434a0e"
import script from "./FormCompletedPage.vue?vue&type=script&lang=js"
export * from "./FormCompletedPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__